var _circle, _path, _path2, _circle2, _g, _g2, _g3, _g4, _g5, _path3, _path4, _g6, _g7, _path5, _path6, _path7, _path8, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _circle3, _circle4, _g15, _g16, _path9, _path0, _path1, _path10, _circle5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircularimage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 578,
    height: 584,
    viewBox: "0 0 578 584",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 287,
    r: 286.5,
    stroke: "#FFF1E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M541.5 287C541.5 424.794 429.572 536.5 291.5 536.5C153.428 536.5 41.5 424.794 41.5 287C41.5 149.206 153.428 37.5 291.5 37.5C429.572 37.5 541.5 149.206 541.5 287Z",
    stroke: "#FFF1E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M508.5 287C508.5 407.123 411.345 504.5 291.5 504.5C171.655 504.5 74.5 407.123 74.5 287C74.5 166.877 171.655 69.5 291.5 69.5C411.345 69.5 508.5 166.877 508.5 287Z",
    stroke: "#FFF1E5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 287,
    r: 141.5,
    stroke: "#FFF1E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2478_1660)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298,
    y: 298,
    width: 73.6667,
    height: 73.6667,
    rx: 36.8333,
    fill: "#FFF1E5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_2478_1660)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.668,
    y: 306.664,
    width: 56.3333,
    height: 56.3333,
    rx: 28.1667,
    fill: "#FFF1E5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2478_1660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.733 334.881C351.733 344.516 343.977 352.328 334.408 352.332H334.221C333.38 352.323 332.542 352.253 331.712 352.123C331.032 352.017 330.359 351.87 329.697 351.683C326.061 350.65 322.86 348.449 320.58 345.417C318.3 342.384 317.066 338.684 317.066 334.881C317.066 325.244 324.825 317.429 334.4 317.429H334.408C336.766 317.427 339.099 317.911 341.265 318.851C343.43 319.791 345.382 321.167 346.999 322.895C350.041 326.134 351.735 330.423 351.733 334.881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.023 329.691V330.476H327.504L320.426 324.551C320.863 323.952 321.339 323.381 321.849 322.844L330.023 329.691ZM348.392 324.583L341.356 330.473H338.772V329.744L346.975 322.873L346.997 322.896C347.47 323.398 347.912 323.928 348.322 324.483L348.392 324.583ZM330.023 339.285V340.07L321.849 346.919C321.776 346.846 321.704 346.768 321.636 346.691C321.206 346.221 320.802 345.727 320.427 345.212L327.504 339.285H330.023ZM348.393 345.179C347.957 345.779 347.484 346.35 346.976 346.888L338.772 340.017V339.285H341.356L348.393 345.179Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.991 330.478H317.625C317.987 329.081 318.52 327.736 319.214 326.473L323.991 330.478ZM323.847 339.286L319.163 343.208C318.493 341.969 317.977 340.652 317.625 339.286H323.847ZM330.027 342.974V351.772C329.917 351.744 329.81 351.714 329.698 351.683C327.427 351.039 325.311 349.933 323.481 348.434L330.027 342.974ZM330.027 317.992V326.652L323.578 321.251C325.476 319.72 327.674 318.609 330.027 317.992ZM345.324 321.332L338.776 326.797V317.993L338.875 318.018C341.233 318.651 343.431 319.781 345.324 321.332ZM351.178 330.478H344.967L349.64 326.563C350.309 327.8 350.825 329.115 351.178 330.478ZM345.379 348.391C343.448 349.986 341.196 351.139 338.78 351.773V342.864L345.379 348.391ZM351.178 339.286C350.834 340.619 350.333 341.905 349.687 343.119L345.111 339.286H351.178Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.733 334.698V335.046C351.726 335.86 351.662 336.672 351.543 337.477H336.979V352.14C336.184 352.259 335.383 352.323 334.58 352.332H334.218C333.415 352.324 332.613 352.259 331.819 352.139V337.477H317.257C317.139 336.676 317.075 335.868 317.066 335.059V334.715C317.074 333.901 317.137 333.088 317.256 332.283H331.821V317.621C332.577 317.508 333.34 317.443 334.104 317.429H334.663C335.393 317.44 336.121 317.497 336.844 317.6L336.979 317.62V332.283H351.542C351.661 333.083 351.725 333.89 351.733 334.698Z",
    fill: "#C8102E"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_2478_1660)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 257,
    width: 73.6667,
    height: 73.6667,
    rx: 36.8333,
    fill: "#FFF1E5"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_2478_1660)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.668,
    y: 265.664,
    width: 56.3333,
    height: 56.3333,
    rx: 28.1667,
    fill: "#FFF1E5"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M269.833 311.565C279.645 311.565 287.6 303.61 287.6 293.798C287.6 283.986 279.645 276.031 269.833 276.031C260.021 276.031 252.066 283.986 252.066 293.798C252.066 303.61 260.021 311.565 269.833 311.565Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M287.6 293.801C287.6 286.757 283.501 280.671 277.558 277.797V309.804C283.501 306.931 287.6 300.844 287.6 293.801ZM252.066 293.801C252.066 300.844 256.166 306.931 262.108 309.804V277.797C256.166 280.671 252.066 286.757 252.066 293.801ZM272.923 296.118L276.013 294.573L274.468 293.801V292.256L271.378 293.801L272.923 290.711H271.378L269.833 288.393L268.288 290.711H266.743L268.288 293.801L265.198 292.256V293.801L263.653 294.573L266.743 296.118L265.971 297.663H269.061V299.98H270.606V297.663H273.695L272.923 296.118Z",
    fill: "#D80027"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dd_2478_1660)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 265,
    width: 73.6667,
    height: 73.6667,
    rx: 36.8333,
    fill: "#FFF1E5"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_2478_1660)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 283.668,
    y: 273.664,
    width: 56.3333,
    height: 56.3333,
    rx: 28.1667,
    fill: "#FFF1E5"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M311.833 319.604C321.645 319.604 329.6 311.649 329.6 301.837C329.6 292.025 321.645 284.07 311.833 284.07C302.021 284.07 294.066 292.025 294.066 301.837C294.066 311.649 302.021 319.604 311.833 319.604Z",
    fill: "#F0F0F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M294.066 301.837C294.066 292.025 302.021 284.07 311.833 284.07C321.645 284.07 329.6 292.025 329.6 301.837",
    fill: "#D80027"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M304.884 293.337C304.884 290.748 306.703 288.586 309.132 288.055C308.752 287.972 308.363 287.93 307.974 287.93C304.987 287.93 302.566 290.351 302.566 293.337C302.566 296.323 304.987 298.744 307.974 298.744C308.372 298.744 308.759 298.7 309.132 298.618C306.703 298.088 304.884 295.925 304.884 293.337ZM311.836 288.316L312.22 289.496H313.46L312.456 290.226L312.84 291.406L311.836 290.676L310.832 291.406L311.216 290.226L310.212 289.496H311.453L311.836 288.316Z",
    fill: "#F0F0F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M308.828 290.633L309.211 291.813H310.452L309.448 292.542L309.832 293.723L308.828 292.993L307.824 293.723L308.207 292.542L307.203 291.813H308.444L308.828 290.633ZM314.848 290.633L315.232 291.813H316.473L315.469 292.542L315.852 293.723L314.848 292.993L313.844 293.723L314.228 292.542L313.224 291.813H314.465L314.848 290.633ZM313.69 294.109L314.073 295.289H315.314L314.31 296.019L314.694 297.199L313.69 296.469L312.686 297.199L313.069 296.019L312.065 295.289H313.306L313.69 294.109ZM309.986 294.109L310.37 295.289H311.611L310.607 296.019L310.99 297.199L309.986 296.469L308.982 297.199L309.366 296.019L308.362 295.289H309.603L309.986 294.109Z",
    fill: "#F0F0F0"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_dd_2478_1660)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 255,
    width: 73.6667,
    height: 73.6667,
    rx: 36.8333,
    fill: "#FFF1E5"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_ii_2478_1660)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232.668,
    y: 263.664,
    width: 56.3333,
    height: 56.3333,
    rx: 28.1667,
    fill: "#FFF1E5"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2478_1660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261 309C270.389 309 278 301.389 278 292C278 282.611 270.389 275 261 275C251.611 275 244 282.611 244 292C244 301.389 251.611 309 261 309Z",
    fill: "#27273D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278 292C278 301.389 270.389 309 261 309C251.611 309 244 301.389 244 292C244 291.572 244.016 291.148 244.047 290.727C244.072 290.386 244.108 290.048 244.153 289.714C244.265 288.879 244.439 288.054 244.674 287.245C244.799 286.815 244.94 286.393 245.098 285.978C245.258 285.554 245.435 285.138 245.629 284.731C246.236 283.45 247 282.25 247.905 281.159C247.984 281.062 248.066 280.967 248.148 280.872C248.351 280.638 248.56 280.409 248.775 280.186C248.865 280.093 248.956 280.003 249.047 279.914C249.107 279.854 249.168 279.795 249.229 279.736C249.291 279.678 249.351 279.621 249.412 279.563C249.712 279.284 250.022 279.016 250.342 278.758H250.346C251.238 278.039 252.202 277.412 253.221 276.887C253.526 276.729 253.836 276.58 254.15 276.441C254.831 276.141 255.53 275.886 256.245 275.679C256.579 275.58 256.917 275.492 257.259 275.413C257.71 275.312 258.168 275.228 258.633 275.163C258.801 275.14 258.971 275.119 259.141 275.101C259.281 275.085 259.422 275.072 259.564 275.06C260.037 275.02 260.517 275 261 275C270.389 275 278 282.611 278 292Z",
    fill: "#1B35A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.564 275.062V276.668L256.317 279.916L255.07 281.161L253.907 282.325L251.752 284.48L250.344 285.887L249.414 286.816L245.502 290.729H244.047C244.072 290.388 244.107 290.05 244.152 289.716C244.265 288.881 244.439 288.056 244.674 287.247L249.412 282.509L249.597 282.325L250.344 281.576L250.761 281.161L254.151 277.77L256.246 275.675C256.579 275.581 256.917 275.494 257.259 275.415C257.71 275.314 258.168 275.231 258.632 275.165C258.801 275.142 258.97 275.121 259.14 275.103C259.281 275.087 259.422 275.074 259.564 275.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.565 287.98V290.727H258.003L254.152 286.875L249.598 282.323L248.435 281.159L248.148 280.872C248.352 280.638 248.561 280.409 248.776 280.186C248.866 280.093 248.956 280.002 249.048 279.914C249.108 279.854 249.169 279.794 249.23 279.736C249.291 279.678 249.352 279.62 249.413 279.563C249.713 279.284 250.022 279.015 250.342 278.758L251.754 280.17L253.909 282.324L256.318 284.733L257.565 285.98L259.565 287.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.139 275.102L254.053 280.187H252.484L253.215 279.456L254.144 278.527L257.252 275.419C257.703 275.318 258.161 275.234 258.625 275.169C258.799 275.141 258.969 275.119 259.139 275.102ZM259.562 288.528V290.097L255.718 286.254H257.287L259.562 288.528ZM249.68 280.187H248.773C248.863 280.094 248.954 280.003 249.045 279.915C249.105 279.855 249.167 279.795 249.228 279.737L249.68 280.187Z",
    fill: "#DB1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.562 279.913V285.979H254.15V290.727H249.41V285.977H245.094C245.254 285.553 245.432 285.137 245.625 284.73C246.232 283.449 246.998 282.249 247.903 281.158C247.982 281.061 248.064 280.965 248.146 280.871C248.349 280.636 248.558 280.407 248.773 280.185C248.863 280.092 248.954 280.001 249.045 279.913H249.41V279.559C249.71 279.28 250.02 279.012 250.34 278.754H250.344C251.237 278.035 252.2 277.408 253.219 276.883C253.524 276.725 253.834 276.577 254.148 276.438V279.913H259.562ZM259.165 300.224L256.595 298.539L258.234 296.101L255.354 297.165L254.422 294.24L253.491 297.165L250.611 296.101L252.251 298.539L249.68 300.224L252.738 300.445L252.251 303.636L254.422 301.243L256.595 303.636L256.107 300.445L259.165 300.224ZM270.829 281.754L269.603 280.95L270.385 279.788L269.011 280.295L268.567 278.9L268.123 280.295L266.749 279.788L267.531 280.95L266.305 281.754L267.764 281.86L267.531 283.382L268.567 282.241L269.603 283.382L269.371 281.86L270.829 281.754ZM265.523 290.49L264.296 289.687L265.079 288.524L263.704 289.031L263.261 287.636L262.816 289.031L261.442 288.524L262.225 289.687L260.998 290.49L262.457 290.596L262.225 292.118L263.261 290.976L264.296 292.118L264.064 290.596L265.523 290.49ZM276.015 287.244L274.789 286.44L275.571 285.278L274.196 285.785L273.753 284.39L273.308 285.785L271.934 285.278L272.717 286.44L271.49 287.244L272.949 287.349L272.717 288.872L273.753 287.73L274.789 288.872L274.556 287.349L276.015 287.244ZM270.829 303.502L269.603 302.699L270.385 301.536L269.011 302.043L268.567 300.648L268.123 302.043L266.749 301.536L267.531 302.699L266.305 303.502L267.764 303.608L267.531 305.13L268.567 303.989L269.603 305.13L269.371 303.608L270.829 303.502ZM272.044 293.329L272.447 294.57H273.753L272.697 295.337L273.1 296.579L272.044 295.812L270.988 296.579L271.391 295.337L270.335 294.57H271.64L272.044 293.329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.66 308.92C262.114 308.973 261.56 309 261 309C251.611 309 244 301.389 244 292C244 291.572 244.016 291.148 244.047 290.727C244.072 290.386 244.108 290.048 244.153 289.714C244.265 288.879 244.439 288.054 244.674 287.245C244.799 286.815 244.94 286.393 245.098 285.978C245.258 285.554 245.435 285.138 245.629 284.731C246.236 283.45 247 282.25 247.905 281.159C247.984 281.062 248.066 280.967 248.148 280.872C248.351 280.638 248.56 280.409 248.775 280.186C248.865 280.093 248.956 280.003 249.047 279.914C249.107 279.854 249.168 279.795 249.229 279.736C249.291 279.678 249.351 279.621 249.412 279.563C249.712 279.284 250.022 279.016 250.342 278.758H250.346C251.238 278.039 252.202 277.412 253.221 276.887C253.526 276.729 253.836 276.58 254.15 276.441C254.831 276.141 255.53 275.886 256.245 275.679C256.579 275.58 256.917 275.492 257.259 275.413C257.71 275.312 258.168 275.228 258.633 275.163C258.801 275.14 258.971 275.119 259.141 275.101C259.281 275.085 259.422 275.072 259.564 275.06C260.037 275.02 260.517 275 261 275C261.56 275 262.113 275.027 262.66 275.08C261.612 275.181 260.576 275.38 259.565 275.674C259.048 275.824 258.542 275.998 258.047 276.195C256.857 276.668 255.725 277.274 254.672 278.001L254.152 278.52V278.374C253.832 278.613 253.522 278.863 253.222 279.124C251.421 280.673 249.964 282.584 248.947 284.731C248.754 285.138 248.577 285.554 248.416 285.978C248.381 286.069 248.35 286.161 248.315 286.253C248.165 286.668 248.032 287.091 247.917 287.521C247.823 287.864 247.74 288.212 247.668 288.563C247.436 289.694 247.32 290.846 247.32 292C247.32 300.832 254.049 308.086 262.66 308.92Z",
    fill: "#1A358E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.564 275.062V275.676C259.047 275.826 258.542 276 258.047 276.197C256.857 276.67 255.725 277.276 254.672 278.003L254.151 278.522V278.376C253.832 278.615 253.522 278.865 253.222 279.126C251.42 280.676 249.964 282.586 248.947 284.733C248.754 285.14 248.577 285.556 248.416 285.98C248.381 286.071 248.349 286.163 248.315 286.255C248.165 286.671 248.032 287.093 247.916 287.523C247.823 287.866 247.74 288.214 247.667 288.566L245.502 290.729H244.047C244.072 290.388 244.107 290.05 244.152 289.716C244.265 288.881 244.439 288.056 244.674 287.247L245.941 285.98L247.187 284.733L249.412 282.509L249.597 282.325L250.344 281.576L250.761 281.161L251.752 280.169L253.219 278.702L254.149 277.773L256.243 275.678C256.578 275.582 256.917 275.494 257.259 275.415C257.71 275.314 258.168 275.231 258.632 275.165C258.801 275.142 258.97 275.121 259.14 275.103C259.281 275.087 259.422 275.074 259.564 275.062Z",
    fill: "#DDDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.937 280.352C251.235 281.099 250.601 281.908 250.044 282.769L249.599 282.325L248.435 281.159L248.148 280.872C248.352 280.638 248.561 280.409 248.776 280.186C248.866 280.093 248.956 280.002 249.048 279.914C249.108 279.854 249.169 279.794 249.23 279.736C249.291 279.678 249.352 279.62 249.413 279.563C249.713 279.284 250.022 279.015 250.342 278.758L251.937 280.352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.14 275.102L258.047 276.196C256.857 276.668 255.725 277.274 254.672 278.002L257.262 275.412C257.713 275.31 258.171 275.227 258.635 275.162C258.801 275.141 258.97 275.119 259.14 275.102Z",
    fill: "#BF1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.68 280.185H248.773C248.863 280.092 248.954 280.001 249.045 279.912C249.105 279.853 249.167 279.793 249.228 279.734L249.68 280.185Z",
    fill: "#DB1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.15 276.438V278.375C253.83 278.614 253.52 278.864 253.22 279.125C251.419 280.675 249.962 282.585 248.945 284.732C248.752 285.139 248.575 285.555 248.414 285.979H245.094C245.254 285.555 245.432 285.14 245.625 284.732C246.232 283.451 246.998 282.251 247.903 281.16C247.982 281.063 248.064 280.968 248.146 280.873C248.349 280.639 248.558 280.41 248.773 280.187C248.863 280.094 248.954 280.004 249.045 279.915H249.41V279.562C249.71 279.283 250.02 279.015 250.34 278.757H250.344C251.237 278.038 252.2 277.411 253.219 276.886C253.523 276.726 253.833 276.577 254.15 276.438Z",
    fill: "#DDDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.564 281.16V284.732H253.218V290.728H250.344V284.732H245.629C246.235 283.451 247 282.251 247.904 281.16H250.344V278.754C251.236 278.035 252.2 277.408 253.218 276.883V281.16H259.564Z",
    fill: "#DB1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.217 276.883V279.125C251.417 280.675 249.962 282.585 248.945 284.732H245.625C246.232 283.451 246.998 282.251 247.903 281.16H250.343V278.754C251.235 278.035 252.198 277.408 253.217 276.883Z",
    fill: "#BF1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.179 286.254L244.708 290.728H244.047C244.072 290.387 244.107 290.049 244.152 289.714L247.614 286.254H249.179Z",
    fill: "#DB1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.316 286.254C248.166 286.669 248.033 287.092 247.918 287.522L244.708 290.728H244.047C244.072 290.387 244.107 290.049 244.152 289.714L247.614 286.254H248.316Z",
    fill: "#BF1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.558 294.416C276.155 294.416 276.639 293.932 276.639 293.335C276.639 292.738 276.155 292.254 275.558 292.254C274.961 292.254 274.477 292.738 274.477 293.335C274.477 293.932 274.961 294.416 275.558 294.416Z",
    fill: "#2548B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.559 291.848C275.981 291.848 276.324 291.505 276.324 291.082C276.324 290.659 275.981 290.316 275.559 290.316C275.136 290.316 274.793 290.659 274.793 291.082C274.793 291.505 275.136 291.848 275.559 291.848Z",
    fill: "#2548B7"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_dd_2478_1660)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 263,
    width: 73.6667,
    height: 73.6667,
    rx: 36.8333,
    fill: "#FFF1E5"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_ii_2478_1660)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282.668,
    y: 271.664,
    width: 56.3333,
    height: 56.3333,
    rx: 28.1667,
    fill: "#FFF1E5"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2478_1660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.833 317.565C320.645 317.565 328.6 309.61 328.6 299.798C328.6 289.986 320.645 282.031 310.833 282.031C301.021 282.031 293.066 289.986 293.066 299.798C293.066 309.61 301.021 317.565 310.833 317.565Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.834 288.984L311.409 290.755H313.271L311.765 291.849L312.34 293.619L310.834 292.525L309.328 293.619L309.903 291.849L308.397 290.755H310.259L310.834 288.984ZM303.187 292.152L304.846 292.997L306.162 291.681L305.871 293.519L307.529 294.364L305.691 294.655L305.399 296.494L304.554 294.835L302.716 295.127L304.032 293.811L303.187 292.152ZM300.02 299.799L301.79 299.224V297.362L302.884 298.868L304.654 298.293L303.56 299.799L304.654 301.305L302.884 300.73L301.79 302.236V300.374L300.02 299.799ZM303.187 307.446L304.032 305.787L302.716 304.471L304.554 304.762L305.399 303.104L305.691 304.942L307.529 305.233L305.871 306.079L306.162 307.917L304.846 306.601L303.187 307.446ZM310.834 310.613L310.259 308.843H308.397L309.903 307.749L309.328 305.979L310.834 307.073L312.34 305.979L311.765 307.749L313.271 308.843H311.409L310.834 310.613ZM318.481 307.446L316.822 306.601L315.506 307.917L315.797 306.078L314.139 305.233L315.977 304.942L316.269 303.104L317.114 304.762L318.952 304.471L317.636 305.787L318.481 307.446ZM321.648 299.799L319.878 300.374V302.236L318.784 300.73L317.014 301.305L318.108 299.799L317.014 298.293L318.784 298.868L319.878 297.362V299.224L321.648 299.799ZM318.481 292.152L317.636 293.811L318.952 295.127L317.114 294.835L316.269 296.494L315.977 294.655L314.139 294.364L315.797 293.519L315.506 291.681L316.822 292.997L318.481 292.152Z",
    fill: "#FFDA44"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_dd_2478_1660)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 283,
    y: 246,
    width: 73.6667,
    height: 73.6667,
    rx: 36.8333,
    fill: "#FFF1E5"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_ii_2478_1660)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.668,
    y: 254.664,
    width: 56.3333,
    height: 56.3333,
    rx: 28.1667,
    fill: "#FFF1E5"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2478_1660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320 301C329.941 301 338 292.941 338 283C338 273.059 329.941 265 320 265C310.059 265 302 273.059 302 283C302 292.941 310.059 301 320 301Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.219 283H338.001C338.001 281.376 337.785 279.802 337.381 278.305H319.219V283Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.219 273.606H335.359C334.258 271.808 332.849 270.219 331.206 268.91H319.219V273.606Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.002 300.999C324.238 300.999 328.132 299.535 331.206 297.086H308.797C311.872 299.535 315.765 300.999 320.002 300.999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.643 292.383H335.359C336.244 290.94 336.93 289.362 337.381 287.688H302.621C303.072 289.362 303.758 290.94 304.643 292.383Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.338 267.811H311.978L310.452 268.919L311.035 270.713L309.51 269.605L307.984 270.713L308.487 269.164C307.144 270.283 305.966 271.594 304.996 273.054H305.522L304.551 273.76C304.399 274.012 304.254 274.269 304.115 274.529L304.579 275.957L303.714 275.328C303.498 275.784 303.302 276.25 303.125 276.725L303.636 278.298H305.522L303.996 279.406L304.579 281.2L303.053 280.092L302.139 280.756C302.048 281.491 302 282.24 302 283H320C320 273.059 320 271.887 320 265C316.444 265 313.129 266.031 310.338 267.811ZM311.035 281.2L309.51 280.092L307.984 281.2L308.567 279.406L307.041 278.298H308.927L309.51 276.504L310.092 278.298H311.978L310.452 279.406L311.035 281.2ZM310.452 274.163L311.035 275.957L309.51 274.848L307.984 275.957L308.567 274.163L307.041 273.054H308.927L309.51 271.261L310.092 273.054H311.978L310.452 274.163ZM317.492 281.2L315.966 280.092L314.44 281.2L315.023 279.406L313.497 278.298H315.383L315.966 276.504L316.549 278.298H318.435L316.909 279.406L317.492 281.2ZM316.909 274.163L317.492 275.957L315.966 274.848L314.44 275.957L315.023 274.163L313.497 273.054H315.383L315.966 271.261L316.549 273.054H318.435L316.909 274.163ZM316.909 268.919L317.492 270.713L315.966 269.605L314.44 270.713L315.023 268.919L313.497 267.811H315.383L315.966 266.017L316.549 267.811H318.435L316.909 268.919Z",
    fill: "#0052B4"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 287,
    r: 103.5,
    fill: "#F6E4D4",
    stroke: "#FFF1E5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 287,
    r: 78.5,
    fill: "#FFF1E5",
    stroke: "#FFF1E5"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_dd_2478_1660)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 238.266,
    y: 234.133,
    width: 106.6,
    height: 106.6,
    rx: 53.3,
    fill: "#FFF1E5"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_ii_2478_1660)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 250.619,
    y: 246.486,
    width: 81.8944,
    height: 81.8944,
    rx: 40.9472,
    fill: "#FFF1E5"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M314.212 263.869C314.212 266.813 313.667 269.728 312.609 272.448C311.552 275.168 310.002 277.639 308.048 279.721C306.093 281.803 303.773 283.454 301.22 284.581C298.667 285.707 295.93 286.287 293.166 286.287V263.869H314.212Z",
    fill: "#0061D3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M268.918 285.83C268.918 282.946 269.462 280.09 270.52 277.426C271.578 274.761 273.128 272.341 275.082 270.301C277.036 268.262 279.356 266.644 281.91 265.541C284.463 264.437 287.2 263.869 289.963 263.869V285.83H268.918Z",
    fill: "#0061D3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M268.918 310.078C268.918 307.194 269.462 304.338 270.52 301.674C271.578 299.009 273.128 296.589 275.082 294.549C277.036 292.51 279.356 290.892 281.91 289.789C284.463 288.685 287.2 288.117 289.963 288.117V310.078H268.918Z",
    fill: "#0061D3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M314.212 288.576C314.212 291.46 313.667 294.316 312.609 296.98C311.552 299.645 310.002 302.065 308.048 304.105C306.093 306.144 303.773 307.761 301.22 308.865C298.667 309.969 295.93 310.537 293.166 310.537V288.576H314.212Z",
    fill: "#0061D3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 287,
    r: 180.5,
    stroke: "#FFF1E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2478_1660",
    x: 268,
    y: 268,
    width: 133.667,
    height: 133.667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.850938 0 0 0 0 0.734224 0 0 0 0 0.634184 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2478_1660"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2478_1660",
    result: "effect2_dropShadow_2478_1660"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2478_1660",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_2478_1660",
    x: 296.668,
    y: 296.664,
    width: 76.3333,
    height: 76.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.850938 0 0 0 0 0.734224 0 0 0 0 0.634184 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2478_1660"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2478_1660",
    result: "effect2_innerShadow_2478_1660"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_2478_1660",
    x: 203,
    y: 227,
    width: 133.667,
    height: 133.667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.850938 0 0 0 0 0.734224 0 0 0 0 0.634184 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2478_1660"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2478_1660",
    result: "effect2_dropShadow_2478_1660"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2478_1660",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_2478_1660",
    x: 231.668,
    y: 255.664,
    width: 76.3333,
    height: 76.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.850938 0 0 0 0 0.734224 0 0 0 0 0.634184 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2478_1660"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2478_1660",
    result: "effect2_innerShadow_2478_1660"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dd_2478_1660",
    x: 245,
    y: 235,
    width: 133.667,
    height: 133.667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.850938 0 0 0 0 0.734224 0 0 0 0 0.634184 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2478_1660"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2478_1660",
    result: "effect2_dropShadow_2478_1660"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2478_1660",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_2478_1660",
    x: 273.668,
    y: 263.664,
    width: 76.3333,
    height: 76.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.850938 0 0 0 0 0.734224 0 0 0 0 0.634184 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2478_1660"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2478_1660",
    result: "effect2_innerShadow_2478_1660"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_dd_2478_1660",
    x: 194,
    y: 225,
    width: 133.667,
    height: 133.667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.850938 0 0 0 0 0.734224 0 0 0 0 0.634184 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2478_1660"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2478_1660",
    result: "effect2_dropShadow_2478_1660"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2478_1660",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_ii_2478_1660",
    x: 222.668,
    y: 253.664,
    width: 76.3333,
    height: 76.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.850938 0 0 0 0 0.734224 0 0 0 0 0.634184 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2478_1660"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2478_1660",
    result: "effect2_innerShadow_2478_1660"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_dd_2478_1660",
    x: 244,
    y: 233,
    width: 133.667,
    height: 133.667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.850938 0 0 0 0 0.734224 0 0 0 0 0.634184 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2478_1660"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2478_1660",
    result: "effect2_dropShadow_2478_1660"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2478_1660",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_ii_2478_1660",
    x: 272.668,
    y: 261.664,
    width: 76.3333,
    height: 76.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.850938 0 0 0 0 0.734224 0 0 0 0 0.634184 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2478_1660"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2478_1660",
    result: "effect2_innerShadow_2478_1660"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_dd_2478_1660",
    x: 253,
    y: 216,
    width: 133.667,
    height: 133.667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.850938 0 0 0 0 0.734224 0 0 0 0 0.634184 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2478_1660"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2478_1660",
    result: "effect2_dropShadow_2478_1660"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2478_1660",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_ii_2478_1660",
    x: 281.668,
    y: 244.664,
    width: 76.3333,
    height: 76.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.850938 0 0 0 0 0.734224 0 0 0 0 0.634184 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2478_1660"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2478_1660",
    result: "effect2_innerShadow_2478_1660"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_dd_2478_1660",
    x: 208.266,
    y: 204.133,
    width: 166.6,
    height: 166.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.850938 0 0 0 0 0.734224 0 0 0 0 0.634184 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2478_1660"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2478_1660",
    result: "effect2_dropShadow_2478_1660"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2478_1660",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_ii_2478_1660",
    x: 240.619,
    y: 236.486,
    width: 101.895,
    height: 101.895,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.850938 0 0 0 0 0.734224 0 0 0 0 0.634184 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2478_1660"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2478_1660",
    result: "effect2_innerShadow_2478_1660"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2478_1660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.6667,
    height: 35.6296,
    fill: "white",
    transform: "translate(317.066 317.066)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2478_1660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(244 275)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2478_1660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.5333,
    height: 35.5333,
    fill: "white",
    transform: "translate(293.066 282.031)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2478_1660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(302 265)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularimage);
export default __webpack_public_path__ + "static/media/circularimage.81526596e7ab859ad32ef9b40c64e4ea.svg";
export { ForwardRef as ReactComponent };